/**
 * @param cookieName {string}
 * @return {string | undefined}
 */
module.exports = function getCookie(cookieName) {
    const cookies = document.cookie.split(";");

    /**
     * @type {string | undefined}
     */
    let x;
    for (let i = 0; i < cookies.length; i++) {
        let [key, value] = cookies[i].split("=");
        key = key.trim();
        if (key === cookieName) {
            x = value;
        }
    }

    return x;
}